<script>
import md5 from "md5";

const tabsName = ["nav-a", "nav-b", "nav-c", "nav-d", "nav-e", "nav-f"];
const ajaxUrl = "http://10.220.168.209:9070";

var isJumpingToLogin = false;
var qid = null;
var userInfo = null;
var user_Q = null;
var user_T = null;
var isVideoClicked = false; //播放器首次加载需要手动点击一次

/**
 * @description 获取ID库模块相关的后端接口路径配置
 * @date 2023-04-24
 * @author
 * @returns {Object} ID库模块相关的后端接口路径配置对象
 */
const getIDLibsAPIs  = () => {
  return {
    getIDLibsList: "/IdLib/getList", // 获取ID库列表
    addIDLib: "/IdLib/add", // 新增ID库
    delIDLib: "/IdLib/del", // 删除ID库
    updateIDLib: "/IdLib/update", // 更新ID库
    getIDLibMembersList: "/IdLib/getMemberList", // 查询ID库成员列表
    addIDLibMember: "/IdLib/addMember", // 新增ID库成员
    updateIDLibMember: "/IdLib/updateMember", // 更新向量成员
    // updateVectorMemberImg: "/VectorLib/uploadImg", // 成员上传图片
    delIDLibMember: "/IdLib/delMember", // 删除新增ID库成员
  }
}

const ajaxAdd = {
  // ID库模块相关的后端接口路径配置对象
  ...getIDLibsAPIs(),
  getListByRelease: "/plugin/getListByRelease",
  // 摄像机关联的AI模板及其结构化分析库数据(列表)
  getStructuredEventList: "/StructuredEvent/getList",
  batchDeleteStructuredEvents: "/StructuredEvent/del",
  getScreenshotTemplateList: "/Template/getList",
  getAlarmEventsList: "/AiEvent/getEventList",
  getDeviceAppliedScreenshotTemplateList: "/Template/getApplyList",
  getCameraScreenshotList: "/Device/getPicList",
  // add or update
  addScreenshotTemplate: "/Template/add",
  updateTemplate: "/Template/upApply",
  deleteScreenshotTemplate: "/Template/del",
  deleteAICustomPlugin: "/plugin/del",
  getScreenshotTemplateDetail: "/Template/getDetail",
  // 截图模板、AI模板
  addScreenshotTemplateToDevice: "/Template/apply",
  upApplyTemplateToCamera: "/Template/upApply",
  switchDeviceScreenshot: "/Template/setSwitch",
  deleteDeviceScreenshot: "Template/delApply",
  getProductList: "/Product/getList",
  addAICustomPlugin: '/plugin/add',
  updateAICustomPlugin: '/plugin/update',
  getAICustomPluginDetail: '/plugin/getPluginById',
  getAICustomPluginList: '/plugin/getList',
  getPublicPluginList:'/plugin/getPublicPluginList', // 我的公共插件管理列表
  delPublicPlugin: '/plugin/delPublicPlugin', // 删除我的公共插件
  addPublicPlugin: '/plugin/addPublicPlugin', // 新增我的公共插件
  getPublicPluginById: '/plugin/getPublicPluginById', // 查询我的公共插件详情
  isAdmin: "user/isAdmin", // 判断是否是管理人员
  updatePublicPlugin: 'plugin/updatePublicPlugin',
  getAdminPublicPluginList:'/plugin/getAdminPublicPluginList',
  getListNotUsed: '/StructuredTable/getListNotUsed',
  deleteCustomAIPlugin: '/plugin/del',
  verifyCode: '/plugin/exec',
  addStructuredTable: '/StructuredTable/add',
  getAllStructuredTablesList: '/StructuredTable/getAllList',
  getDropDownList: '/StructuredTable/getDropDownList',
  updateStructuredTable: '/StructuredTable/update',
  getStructuredTableList: '/StructuredTable/getList',
  // getListNotUsed: '/StructuredTable/getListNotUsed',
  deleteStructuredTable: "/StructuredTable/del",
  getDeviceList: "/Device/getList",
  addDevice: "/Device/addDevice",
  delDevice: "/Device/del",
  upDevice: "/Device/upDevice",
  getGroupList: "/Group/getAllList",
  addGroup: "/Group/add",
  delGroup: "/Group/del",
  upDeviceGroup: "/Device/upDeviceGroup",
  getInfoBySn: "/Device/getInfoBySn",
  addDeviceSkill: "/Device/addDeviceSkill",
  getDeviceSkill: "/Device/getDeviceSkill",
  getEventList: "/Device/getEventList",
  getEventCount: "/Device/getEventCount",
  handleDeviceEvent: "/Device/handleDeviceEvent",
  delDeviceEvent: "/Device/delDeviceEvent",
  checkUser: "/User/checkUser",
  getTocList: "/UserDevice/getList",
  addUser: "/User/addUser",
  upEventData: "/Device/upEventData",
  oneKeyHandleEvent: "/Device/oneKeyHandleEvent",
  getCarGroupList: "/Car/getGroupList",
  addCarGroup: "/Car/addGroup",
  updateCarGroup: "/Car/upGroupInfo",
  deleteCarGroup: "/Car/delGroup",
  getCarNumberList: "/Car/getNumberList",
  addCarNumber: "/Car/addNumber",
  upCarNumberInfo: "/Car/upNumberInfo",
  deleteCarNumber: "/Car/delNumber",
  getFaceGroupList: "/Face/getGroupList",
  addFaceGroup: "/Face/addGroup",
  updateFaceGroup: "/Face/upGroupInfo",
  deleteFaceGroup: "/Face/delGroup",
  getFaceNumberList: "/Face/getNumberList",
  uploadImg: "/Face/uploadImg",
  addFaceNumber: "/Face/addNumber",
  deleteFaceNumber: "/Face/delNumber",
  updateFaceInfo: "/Face/upNumberInfo",
  getSkillList: "/Skill/getSkillList",
  addSkill: "/Skill/addSkill",
  upSkill: "/Skill/upSkill",
  delSkill: "/Skill/delSkill",
  getQvod: "/Device/getQvodUrl",
  getEventDay: "/Total/getEventDay",
  getEventTrend: "/Total/getEventTrend",
  getDeviceCount: "/Total/getDeviceCount",
  getSkillEventTrend: "/Total/getSkillEventTrend",
  getEventDeviceTop: "/Total/getEventDeviceTop",
  getSettingInfo: "/UserSetting/getSettingInfo",
  alertSetting: "/UserSetting/alertSetting",
  getDatasetList: "/Updata/getDatasetList",
  upEventData: "/Updata/upEventData",
  createDataset: "/Updata/createDataset",
  dataSetCreate: "/DeviceQvod/dataSetCreate",
  getModel: "/Updata/getModel",
  getDeviceEvent: "/Device/getDeviceEvent",
  getLinkToken: "/User/getRoomToken",
  getGenerateNumber: "/VIID/GenerateNumber",
  getNewsCount: "/News/getNewsCount", // 获取站内信未读数
  getNewsList: "/News/getList", // 获取站内信列表
  readMsg: "/News/readMsg", // 读站内信
  delMsg: "/News/delMsg", // 删除站内信
  getUserConfig: "/User/getUserConfig", // 获取用户配置信息
  checkOssCount: "/User/checkOssCount", // 检测用户是否可以开启云存
  getThirdServer: "/UserSetting/getThirdServer", //获取第三方请求地址以及token
  thirdServerInfo: "/UserSetting/thirdServerInfo", //设置第三方请求地址以及token
  getVectorIdLibList: "/Template/getVectorIdLibList", // 获取向量ID库
  // 向量库
  getVectorLibList: "/VectorLib/getList", // 获取向量库列表
  addVectorLib: "/VectorLib/add", // 新增向量库
  delVectorLib: "/VectorLib/del", // 删除向量库
  updateVectorLib: "/VectorLib/update", // 更新向量库
  getVectorMemberList: "/VectorLib/getMemberList", // 查询向量成员
  addVectorMember: "/VectorLib/addMember", // 新增向量成员
  updateVectorMember: "/VectorLib/updateMember", // 更新向量成员
  updateVectorMemberImg: "/VectorLib/uploadImg", // 成员上传图片
  delVectorMember: "/VectorLib/delMember", // 成员上传图片
};
const ajaxSkill = {
  getModeInstanceList: "/SkillConfig/getModeInstanceList", //模型管理列表
  addModeInstance: "/SkillConfig/addModeInstance", //添加模型实例
  generateLatestModeVersion: "/SkillConfig/generateLatestModeVersion", //获取主key对应的version
  ReleaseMode: "/SkillConfig/ReleaseMode", //模型发布
  getModeKeys: "/SkillConfig/getModeKeys", //获取模型Keys
  deleteModeInstance: "/SkillConfig/deleteModeInstance", //删除模型实例
  upModeInstance: "/SkillConfig/upModeInstance", //更新模型信息
  getPluginInstanceList: "/SkillConfig/getPluginInstanceList", //技能插件管理列表
  getSkillVersionList: "/SkillConfig/getSkillVersionList", //技能版本列表
  getPluginKeys: "/SkillConfig/getPluginKeys", //获取插件Keys
  upPluginInstance: "/SkillConfig/upPluginInstance", //更新插件信息
  generateLatestPluginVersion: "/SkillConfig/generateLatestPluginVersion", //获取插件主key对应的version
  addPluginInstance: "/SkillConfig/addPluginInstance", //添加插件实例
  deletePluginInstance: "/SkillConfig/deletePluginInstance", //删除插件实例
  ReleasePlugin: "/SkillConfig/ReleasePlugin", //插件实例发布
  getSKUDeviceList: "/SkillConfig/getSKUDeviceList", //sku信息表
  addSKUDevice: "/SkillConfig/addSKUDevice", //添加SKU设备
  upSKUDevice: "/SkillConfig/upSKUDevice", //更新SKU设备
  getDeviceSkillMatchList: "/SkillConfig/getDeviceSkillMatchList", //设备支持技能配置列表
  getSkillList: "/SkillConfig/getSkillList", //获取技能列表(小东)
};
//试用中
var user_level = 0;

var deviceTypes = {
  box: 1,
  camera: 2,
};

const signToken = "465a88a07cc1dab18abda500ae3b9bf0";
const defaultUserInfo = {
  user_name: "10010",
  pwd: "123456",
};
const defaultImei = "20200205";
const localStorageUserInfo = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : {};

function getUrldata(data) {
  let urlsign = "";
  const postdata = Object.assign({}, data);
  const newKeyData = Object.keys(postdata).sort();
  for (var i = 0; i < newKeyData.length; i++) {
    // 按字典顺序排序
    let key = newKeyData[i];
    urlsign += key + "=" + postdata[key];
  }
  urlsign += signToken;
  urlsign = md5(urlsign);
  return urlsign;
}

var menuInfo = [
  { index: 6, path: "overview", name: "总览" },
  { index: 0, path: "device", name: "设备管理" },
  { index: 1, path: "live", name: "实时监控" },
  //   { index: 5, path: "record", name: "云存回放" },
  { index: 2, path: "event", name: "事件管理" },
  { index: 3, path: "ai", name: "技能中心" },
  //   { index: 4, path: "doc", name: "使用文档" },
  { index: 7, path: "statistics", name: "数据统计" },
  { index: 8, path: "set", name: "设置" },
  { index: 101, path: "user", name: "用户中心" },
  { index: 102, path: "push", name: "推流工具" },
  { index: 103, path: "general_skill_configuration", name: "云存配置" },
];
var menuInfo_view = [
  { index: 1, path: "live", name: "实时监控" },
  { index: 101, path: "user", name: "用户中心" },
];

//云存视频是否上传，以及上传频率的配置
var time_horizons = {
  param_name: "time_horizons",
  param_data_type: 14,
  param_show: true,
  param_show_type: 7,
  param_title: "运行时间",
  param_desc: "配置运行时间规则",
  param_default_val: [
    {
      weekly_day: [1, 2, 3, 4, 5, 6, 7],
      horizonList: [0, 86399000],
      weekly_list: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
    },
  ],
  param_val: [],
};
// 抽帧策略默认配置
var frame_strategy = {
  param_name: "frame_extracting_interval",
  param_data_type: 1,
  param_default_val: 1000,
  param_desc: "单位时长内抽取的帧数（格式：每 xx 秒（分钟/小时）抽取 xx 帧）",
  param_interval_frame: 1,
  param_interval_frame_max: 10,
  param_interval_frame_min: 1,
  param_interval_pic: { 1: "秒", 2: "分钟", 3: "小时" },
  param_interval_pic_default: 1,
  param_max_val: 86400000,
  param_min_val: 1000,
  param_set_desc: "**频率最大值为1帧/24小时，最小值为1帧/秒**",
  param_show: true,
  param_show_type: 8,
  param_temp: {
    every_second: 1,
    param_default_val_prop: 1,
    param_interval_pic_max: 3,
    param_interval_pic_min: 1,
    param_max_val_prop: 86400,
    param_min_val_prop: 1,
    second_max: 10,
    second_min: 1,
    second_num: 1,
    time_pic_val: 1,
  },
  param_title: "抽帧间隔",
  param_val: 1000,
};
var allSkills = [];
var switchAlarm = null;
//将技能数组数据解析成对象数组，val：config配置文件；data：实际数据，结构：{skill_config:xxx,skill_data:xxx}
function parseSkillData(val, data) {
  var sks = data.skill_data;
  //将有效的真实数据拼成数组
  var dataList = [];
  for (var a = 0; a < sks.length; a++) {
    var sk = JSON.parse(sks[a].skill_data);
    {
      if (!sk.length || sk.length == 0 || !sk[0].length || sk[0].length == 0) {
        continue;
      }
      dataList.push(JSON.parse(JSON.stringify(sk)));
    }
  }
  var list = [];
  //解析config配置，用于技能ui的显示，再从真实数据中获取param_val赋值给config，展示设备自己的值
  for (var i = 0; i < val.length; i++) {
    var temp_data = {};
    //获取真实数据
    var real_skill = getSameSkill(val[i], dataList);
    //遍历技能属性
    for (var h = 0; h < val[i].length; h++) {
      var param = val[i][h];
      //解析服务器数据，获取实际值
      if (param.param_name == "skill_name") {
        //skill_name中包含技能名称和描述，描述用<br>分割换行
        temp_data.name = param.param_title;
        if (param.param_desc != "") {
          //将描述分割成数组
          var desc = param.param_desc.split("<br>");
          temp_data.skill_desc = desc;
        }
        temp_data.result_desc = param.result_desc;
      } else if (param.param_name == "type") {
        //技能类型：通用技能
        temp_data.type = param.param_default_val;
      } else if (param.param_name == "skill_show") {
        //是否显示该技能，false的技能在列表中看不到
        temp_data.skill_show = param.param_default_val;
      } else if (param.param_name == "time_horizons") {
        //设置视频拉流的频率
        var p_real7 = getValByKey(real_skill, "time_horizons");
        if (p_real7) {
          temp_data.time_horizons = p_real7.param_val;
        } else {
          temp_data.time_horizons = JSON.parse(
            JSON.stringify(time_horizons.param_default_val)
          );
        }
      } else if (param.param_name == "use_suspect") {
        //是否开启疑似：开关
        var p_real = getValByKey(real_skill, "use_suspect");
        if (p_real) {
          //有真实数据使用param_val，没有真实数据使用param_default_val
          temp_data.use_suspect = p_real.param_val;
        } else {
          temp_data.use_suspect = param.param_default_val;
        }
      } else if (param.param_name == "result_desc") {
        //事件上报时展示的文案内容
        temp_data.result_desc = param.param_val;
      } else if (param.param_name == "skill_id") {
        //技能id，不可重复
        temp_data.id = param.param_default_val;
      } else if (param.param_name == "on") {
        //开关：是否开启技能
        var p_real2 = getValByKey(real_skill, "on");
        if (p_real2) {
          temp_data.on = p_real2.param_val;
        } else {
          temp_data.on = param.param_default_val;
        }
      } else if (param.param_name == "check_region") {
        //分析区域，二维坐标。技能关闭后，二维坐标清空
        var p_real6 = getValByKey(real_skill, "check_region");
        if (p_real6) {
          temp_data.check_region = p_real6.param_val;
        } else {
          temp_data.check_region = param.param_default_val;
        }
      } else if (param.param_name == "alarm_period") {
        //与ai同级参数，保存在skill_list中
        //告警周期
        if (!temp_data.skill_list) {
          temp_data.skill_list = [];
        }
        var sk_data = {
          param_name: param.param_name,
          param_title: param.param_title,
          param_min_val: param.param_min_val, //配置下限
          param_max_val: param.param_max_val, //配置上限
          param_option: param.param_min_val + "-" + param.param_max_val, //暂不使用
          param_default_val: param.param_default_val, //默认值
          param_type: 2,
          show_type: 4,
        };
        var p_real4 = getValByKey(real_skill, "alarm_period");
        if (p_real4) {
          sk_data.param_val = p_real4.param_val;
        } else {
          sk_data.param_val = param.param_default_val;
        }
        if (param.param_desc != "") {
          var desc2 = param.param_desc.split("<br>");
          sk_data.param_desc = desc2;
        }
        temp_data.skill_list.push(sk_data);
      } else if (param.param_name == "ai_params") {
        //解析ai
        temp_data.ai_data = [];
        var ais = param.param_val;
        for (var j = 0; j < ais.length; j++) {
          var ai = ais[j];
          if (!temp_data.ai_data[j]) {
            temp_data.ai_data[j] = {};
          }
          for (var k = 0; k < ai.length; k++) {
            var ai_param = ai[k];
            if (ai_param.param_name == "ai_id") {
              temp_data.ai_data[j].id = ai_param.param_default_val;
            } else if (ai_param.param_name == "ai_name") {
              temp_data.ai_data[j].name = ai_param.param_title;
            } else if (
              ai_param.param_name == "ai_confidence" ||
              ai_param.param_name == "ai_suspect_confidence" ||
              ai_param.param_name == "quantity"
            ) {
              //置信度、意思置信度、人数上限，目前ai中的这三个参数需要设置。其中置信度和疑似置信度显示为一个gslider组件
              if (!temp_data.ai_data[j].param_data) {
                temp_data.ai_data[j].param_data = [];
              }
              var param_data = {
                param_name: ai_param.param_name,
                param_title: ai_param.param_title,
                param_min_val: ai_param.param_min_val, //最小值
                param_max_val: ai_param.param_max_val, //最大值
                param_option:
                  ai_param.param_min_val + "-" + ai_param.param_max_val,
                param_default_val: ai_param.param_default_val,
              };
              var p_real3 = getValByKey(
                real_skill,
                "ai_params",
                ai_param.param_name
              );
              if (p_real3) {
                param_data.param_val = p_real3.param_val;
              } else {
                param_data.param_val = ai_param.param_default_val;
              }
              if (ai_param.param_name == "quantity") {
                //设置人数上限
                param_data.param_type = 2;
                param_data.show_type = 4; //4是数字输入框
              } else {
                param_data.param_type = 1;
                param_data.show_type = 1; //gslider滑条
              }
              if (ai_param.param_desc != "") {
                var desc2 = ai_param.param_desc.split("<br>");
                param_data.param_desc = desc2;
              }
              temp_data.ai_data[j].param_data.push(param_data);
            } else if (
              ai_param.param_name == "ai_hit_list" ||
              ai_param.param_name == "ai_non_hit_list"
            ) {
              //命中列表和非命中列表，也可同时存在
              if (!temp_data.ai_data[j].param_data) {
                temp_data.ai_data[j].param_data = [];
              }
              //ai_recognize_group_type：绝对使用人脸库还是车牌库，二选一
              var group = getParamByKey(ai, "ai_recognize_group_type");
              var param_data2 = {
                param_name: ai_param.param_name,
                param_title: ai_param.param_title,
                param_default_val: ai_param.param_default_val,
              };
              if (group) {
                //ui上用此参数绝对加载什么库
                param_data2.param_group_type = group.param_default_val;
              }
              param_data2.param_type = 3;
              param_data2.show_type = 5; //多选框
              param_data2.param_set_desc = ai_param.param_set_desc;
              var p_real5 = getValByKey(
                real_skill,
                "ai_params",
                ai_param.param_name
              );

              if (p_real5) {
                param_data2.param_val = p_real5.param_val;
              } else {
                param_data2.param_val = ai_param.param_val;
              }
              temp_data.ai_data[j].param_data.push(param_data2);
            }
          }
        }
      }
    }
    if (!temp_data.hasOwnProperty("skill_show")) {
      temp_data.skill_show = false;
    }
    //开启拉流配置
    if (!temp_data.hasOwnProperty("time_horizons")) {
      var p_real8 = getValByKey(real_skill, "time_horizons");
      if (p_real8) {
        temp_data.time_horizons = p_real8.param_val;
      } else {
        temp_data.time_horizons = JSON.parse(
          JSON.stringify(time_horizons.param_default_val)
        );
      }
    }
    // 抽帧策略抽帧频率
    if (!temp_data.hasOwnProperty("frame_extracting_interval")) {
      var p_real9 = getValByKey(real_skill, "frame_extracting_interval");
      if (p_real9) {
        temp_data.frame_strategy = p_real9;
      } else {
        temp_data.frame_strategy = JSON.parse(JSON.stringify(frame_strategy));
      }
    }
    list.push(temp_data);
  }
  return list;
}
function getParamByKey(item, key) {
  for (var i = 0; i < item.length; i++) {
    if (item[i].param_name == key) {
      return item[i];
    }
  }
  return {};
}
function getValByKey(skill, key, subkey) {
  if (!skill) {
    return null;
  }
  for (let i = 0; i < skill.length; i++) {
    let param = skill[i];
    if (!subkey) {
      if (param.param_name == key) {
        return param;
      }
    } else {
      if (param.param_name == "ai_params") {
        for (let k = 0; k < param.param_val.length; k++) {
          let ai = param.param_val[k];
          for (let j = 0; j < ai.length; j++) {
            let ai_param = ai[j];
            if (ai_param.param_name == subkey) {
              {
                return JSON.parse(JSON.stringify(ai_param));
              }
            }
          }
        }
      }
    }
  }
  return null;
}

function getSameSkill(config, dataList) {
  for (var i = 0; i < config.length; i++) {
    if (config[i].param_name == "skill_id") {
      for (var j = 0; j < dataList.length; j++) {
        for (var k = 0; k < dataList[j].length; k++) {
          for (var l = 0; l < dataList[j][k].length; l++) {
            if (
              dataList[j][k][l].param_name == "skill_id" &&
              config[i].param_default_val == dataList[j][k][l].param_default_val
            ) {
              return JSON.parse(JSON.stringify(dataList[j][k]));
            }
          }
        }
      }
    }
  }
}

function getMenuIndex(path) {
  var menuIndex = 0;
  switch (path) {
    case "device":
    case "":
    case "/device":
    case "main":
    case "/main":
      menuIndex = 0;
      break;
    case "live":
    case "/live":
      menuIndex = 1;
      break;
    case "event":
    case "/event":
      menuIndex = 2;
      break;
    case "ai":
    case "/ai":
      menuIndex = 3;
      break;
    case "doc":
    case "/doc":
      menuIndex = 4;
      break;
    case "overview":
    case "/overview":
      menuIndex = 6;
      break;
    case "statistics":
    case "/statistics":
      menuIndex = 7;
      break;
    case "set":
    case "/set":
      menuIndex = 8;
      break;
    case "user":
    case "/user":
      menuIndex = 101;
      break;
    case "push":
    case "/push":
      menuIndex = 102;
      break;
    case "config":
    case "/config":
      menuIndex = 103;
      break;
  }
  //   console.log("getMenuIndex", path, menuIndex);
  return menuIndex;
}

function formatGroupKey(v) {
  if (!v) {
    return null;
  }
  if (typeof v.length == "number") {
    for (var i = 0; i < v.length; i++) {
      var vc = v[i];
      for (let key in vc) {
        if (key == "id") {
          vc["key"] = vc.id;
          vc["value"] = vc.id; //在对象中添加了myId键名,并把当前key值赋值给了myId
          vc["label"] = vc.title;
          //   delete vc[key]; //删除当前键名为id的属性
        }
      }
      vc["scopedSlots"] = { title: "custom" };
      if (vc.hasOwnProperty("children") && vc.children.length > 0) {
        formatGroupKey(vc.children);
      }
    }
  } else {
    for (let key in v) {
      if (key == "id") {
        v["key"] = v.id; //在对象中添加了myId键名,并把当前key值赋值给了myId
        v["value"] = v.id;
        v["label"] = v.title;
        //   delete vc[key]; //删除当前键名为id的属性
      }
    }
    v["scopedSlots"] = { title: "custom" };
    if (v.hasOwnProperty("children") && v.children.length > 0) {
      formatGroupKey(v.children);
    }
  }
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
//获取cookie
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
//清除cookie
function clearCookie() {
  setCookie("username", "", -1);
}
//删除指定cookie的值
function removeCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  var cookieStr = "";
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      document.cookie = c + ";expires=" + new Date(0).toUTCString();
    } else {
      cookieStr += c;
      cookieStr += ";";
    }
    document.cookie = cookieStr;
  }
}
function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}
function getPostData(data) {
  let params = "";
  for (let index in data) {
    params += index + "=" + data[index] + "&";
  }
  return params;
}

function getModel(model) {
  if (!model) {
    return [];
  }
  if (typeof model != "string" || model.length == 0) {
    return [];
  }
  var model = model.split(",");
  var arr = [];
  for (var i = 0; i < model.length; i++) {
    var val = parseInt(model[i]);
    var tag = {
      name: getModelName(val),
      color: getTagColor(val),
    };
    arr.push(tag);
  }
  return arr;
}
function getSkills(skill) {
  if (!skill) {
    return [];
  }
  var skills = skill.split(",");
  var arr = [];
  for (var i = 0; i < skills.length; i++) {
    var val = parseInt(skills[i]);
    var tag = {
      name: getTagName(val),
      color: getTagColor(val),
    };
    arr.push(tag);
  }
  return arr;
}
function getModelName(type) {
  switch (parseInt(type)) {
    case 1:
      return "设备管理";
    case 2:
      return "实时监控";
    case 3:
      return "事件管理";
    case 4:
      return "AI工具箱";
    case 5:
      return "使用文档";
    case 6:
      return "个人中心";
  }
  return "设备管理";
}
function getTagName(type) {
  switch (parseInt(type)) {
    case 1:
      return "安全帽";
    case 2:
      return "电子围栏";
    case 3:
      return "手势识别";
    case 4:
      return "车位";
    case 5:
      return "陌生人";
    case 6:
      return "人员流动";
    case 7:
      return "烟火检测";
  }
  return "烟火检测";
}
function getTagColor(type) {
  switch (parseInt(type)) {
    case 1:
      return "pink";
    case 2:
      return "cyan";
    case 3:
      return "red";
    case 4:
      return "blue";
    case 5:
      return "orange";
    case 6:
      return "purple";
    case 7:
      return "green";
  }
  return "cyan";
}

/*
target:jquery的拖拽目标class或id
panel：panel的jquery对象
left、top：panel的偏移坐标
*/
function movePanel(target, panel, left, top) {
  $(document).off("mousedown", target);
  $(document).on("mousedown", target, function (e) {
    e.stopPropagation();
    var pos = getMousePosition(e, panel);
    var scrolltopTemp =
      document.documentElement.scrollTop || document.body.scrollTop;
    var l = e.pageX - pos.x + left;
    var t = e.pageY - pos.y + top;
    if (t > $(window).height() + panel.height() / 2 - 80 + scrolltopTemp) {
      t = $(window).height() + panel.height() / 2 - 80 + scrolltopTemp;
    }
    panel.css({
      left: l + "px",
      top: t - scrolltopTemp + "px",
    });

    $(document).on("mouseup", (e) => {
      $(document).off("mouseup");
      $(document).off("mousemove");
    });
    $(document).on("mousemove", (e) => {
      e.stopPropagation();
      var l = e.pageX - pos.x + left;
      var t = e.pageY - pos.y + top;
      if (t < top) {
        t = top;
      }
      if (t > $(window).height() + panel.height() / 2 - 80 + scrolltopTemp) {
        t = $(window).height() + panel.height() / 2 - 80 + scrolltopTemp;
      }
      panel.css({
        left: l + "px",
        top: t - scrolltopTemp + "px",
      });
    });
  });
}

//拖拽移动时，需要获取一个相对坐标，用于标记鼠标落下在目标内部时的哪个点
function getMousePosition(e, middle) {
  //获取div中鼠标的相对坐标
  var posX = 0;
  var posY = 0;
  var conX = middle.offset().left;
  var conY = middle.offset().top;
  var event = event || window.event;
  if (event.pageX || event.pageY) {
    posX = event.pageX;
    posY = event.pageY;
  } else if (event.clientX || event.clientY) {
    posX =
      event.clientX +
      document.documentElement.scrollLeft +
      document.body.scrollLeft;
    posY =
      event.clientY +
      document.documentElement.scrollTop +
      document.body.scrollTop;
  }
  return { x: posX - conX, y: posY - conY };
}

function copyData(data) {
  var newData = [];
  if (typeof data.length == "number") {
    for (var i = 0; i < data.length; i++) {
      newData.push(Object.assign({}, data[i]));
    }
  } else {
    newData = Object.assign({}, data);
  }
  return newData;
}

//数组合并并去重函数,key为判断依据
function MergeArray(arr1, arr2, key) {
  var _arr = [];
  for (var i = 0; i < arr1.length; i++) {
    _arr.push(arr1[i]);
  }
  for (var i = 0; i < arr2.length; i++) {
    var flag = true;
    for (var j = 0; j < arr1.length; j++) {
      if (arr2[i][key] == arr1[j][key]) {
        flag = false;
        break;
      }
    }
    if (flag) {
      _arr.push(arr2[i]);
    }
  }
  return _arr;
}

function randomCoding() {
  var result = [];
  var n = 10; //这个值可以改变的，对应的生成多少个字母，根据自己需求所改
  for (var i = 0; i < n; i++) {
    //生成一个0到25的数字
    if (Math.floor(Math.random() * 100) % 2 == 1) {
      var ranNum = Math.ceil(Math.random() * 25);
      //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;
      //然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
      result.push(String.fromCharCode(65 + ranNum));
    } else {
      result.push("" + Math.floor(Math.random() * 10));
    }
  }
  return "360" + result.join("");
}

function axios(that, url, data, isForm, token) {
  data.reg_time = new Date().getTime();
  return new Promise(function (resolve, reject) {
    // that.$axios.defaults.withCredentials = true;
    // console.log(global.getCookie("T"));
    var d_ = null;
    if (!isForm) {
      d_ = {
        transformRequest: [
          function (data) {
            let params = "";
            for (let index in data) {
              params += index + "=" + data[index] + "&";
            }
            return params;
          },
        ],
      };
    }
    that.$axios
      .post("/api" + url, data, d_)
      .then(function (res) {
        if (res && res.data && res.data.errno == 0) {
          if (resolve) {
            resolve(res.data);
          }
        } else {
          reject(res);
          var errmsg_ = null;
          if (res.hasOwnProperty("errmsg")) {
            errmsg_ = res.errmsg;
          } else if (res.data.hasOwnProperty("errmsg")) {
            errmsg_ = res.data.errmsg;
          }
          that.alertTitle = "请求失败";
          that.alertLabel = "";
          that.alertLabel_before = errmsg_ + "，";
          if (!token) {
            that.alertShow = true;
          }
        }
      })
      .catch(function (e) {
        reject(e);
        if (e.hasOwnProperty("errmsg")) {
          msg(that, e.errmsg, "error");
        }
      });
  });
}
function msg(that, text, type) {
  that.$msg.destroy();
  if (type == "success") {
    that.$msg.success(text);
  } else if (type == "error") {
    that.$msg.error(text);
  } else if (type == "info") {
    that.$msg.info(text);
  }
}
function draw(id, item) {
  var canvas = document.getElementById(id);
  if (!canvas) {
    return;
  }
  var w = canvas.offsetWidth;
  var h = canvas.offsetHeight;
  var ctx = canvas.getContext("2d");
  canvas.width = w;
  canvas.height = h;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.beginPath();
  for (var j = 0; j < item.skill_data.ai_check_result.length; j++) {
    var ai = item.skill_data.ai_check_result[j];
    var color = getColorByAiId(ai.ai_id);
    drawSmallPic(ctx, canvas, ai.ai_check_region, j, color);
  }
}
/**
 *
 * @description 告警事件 draw
 * @date 2022-12-13
 * @param {any} id
 * @param {any} item
 */
function drawAlarm(id, item) {
  var canvas = document.getElementById(id);
  if (!canvas) {
    return;
  }
  var w = canvas.offsetWidth;
  var h = canvas.offsetHeight;
  var ctx = canvas.getContext("2d");
  canvas.width = w;
  canvas.height = h;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.beginPath();
  for (var j = 0; j < item.ai_check_results.length; j++) {
    var ai = item.ai_check_results[j];
    var color = getColorByAiId(ai.ai_id);
    drawAlarmSmallPic(ctx, canvas, item.ai_check_results, j, color);
  }
}
function drawSmallPic(ctx, canvas, points, index, color) {
  console.group("drawSmallPic");
  console.log({ ctx, canvas, points, index, color });
  console.groupEnd();
  for (var i = 0; i < points.length; i++) {
    var x = points[i].x * canvas.width;
    var y = points[i].y * canvas.height;
    var w = points[i].w * canvas.width;
    var h = points[i].h * canvas.height;
    ctx.moveTo(x, y); //从A（100,0）开始
    ctx.rect(x, y, w, h);
    // console.log(index, i, x, y, w, h, points);
  }
  ctx.closePath();
  ctx.strokeStyle = color;
  ctx.stroke();
}
function drawAlarmSmallPic(ctx, canvas, points, index, color) {
  console.group("drawAlarmSmallPic");
  console.log({ ctx, canvas, points, index, color });
  console.groupEnd();
  for (var i = 0; i < points.length; i++) {
    var x = points[i].x * canvas.width;
    var y = points[i].y * canvas.height;
    var w = points[i].w * canvas.width;
    var h = points[i].h * canvas.height;
    ctx.moveTo(x, y); //从A（100,0）开始
    ctx.rect(x, y, w, h);
    // console.log(index, i, x, y, w, h, points);
  }
  ctx.closePath();
  ctx.strokeStyle = color;
  ctx.stroke();
}
function getColorByAiId(ai_id) {
  // console.log(ai_id);debugger
  switch (ai_id) {
    case 1:
      return "#03db0b"; //"#ff0000";
    case 2:
      return "#03db0b"; //"#ff00ff";
    case 3:
      return "#03db0b"; //"#00ffff";
    case 4:
      return "#03db0b"; //"#00ffff";
    case 5:
      return "#03db0b"; //"#ffff00";
    case 6:
      return "#03db0b"; //"#00ff00";
    case 7:
      return "#03db0b"; //"#ffd591";
    case 8:
      return "#03db0b"; //"#b7eb8f";
    case 9:
      return "#03db0b"; //"#f6ffed";
    case 10:
      return "#03db0b"; //"#87e8de";
    case 11:
      return "#03db0b"; //"#52c41a";
    case 12:
      return "#03db0b"; //"#13c2c2";
    case 13:
      return "#03db0b"; //"#d3adf7";
    case 14:
      return "#03db0b"; //"#722ed1";
    case 15:
      return "#03db0b"; //"#91d5ff";
    case 16:
      return "#03db0b"; //"#1890ff";
    case 17:
      return "#03db0b"; //"rgb(255, 85, 0)";
    case 18:
      return "#03db0b"; //"rgb(45, 183, 245)";
    case 19:
      return "#03db0b"; //"rgb(135, 208, 104)";
    case 20:
      return "#03db0b"; //"#ffadd2";
    case 21:
      return "#03db0b"; //"rgb(16, 142, 233)";
    case 22:
      return "#03db0b"; //"#ffffff";
    case 23:
      return "#03db0b"; //"#eb2f96";
    case 24:
      return "#03db0b"; //"#000000";
    case 25:
      return "#03db0b"; //"#075e5e";
    case 26:
      return "#03db0b"; //"#6cf01c";
    case 27:
      return "#03db0b"; //"#fd05e9";
    case 28:
      return "#03db0b"; //"#fde905";
    case 29:
      return "#03db0b"; //"#1c21e5";
    case 30:
      return "#03db0b"; //"#686983";
    case 31:
      return "#03db0b"; //"#6366d4";
  }
  return "#03db0b"; //"rgb(255, 85, 0)";
}

var emojiReg =
  /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
function noEmoji(dom) {
  var html = $(dom).val(),
    oldHtml = "";
  oldHtml = html;

  if (html.match(emojiReg)) {
    html = html.replace(emojiReg, "");
  }
  if (html != oldHtml) {
    $(dom).val(html);
  }
}

var eventTipTimer = 0;
var eventTipNums = 0;
var eventTipsaveNums = -1;

function ksort(object) {
  let sortArr = Object.keys(object);
  sortArr = sortArr.sort();
  const obj = {};

  sortArr.forEach((item, i) => {
    obj[item] = object[item];
  });
  return obj;
}

function getKV(obj, seg = "") {
  let str = "";
  if (obj) {
    for (const i in obj) {
      str += seg + i + "=" + obj[i];
    }
  }
  return str;
}
function logOut(that, res) {
  console.log(
    this,
    "退出登录：",
    "环境：" + process.env.NODE_ENV,
    isJumpingToLogin,
    "用户信息：",
    this.userInfo,
    "qid:" + this.qid
  );
  if (process.env.NODE_ENV == "private") {
    this.removeCookie("online_ticket");
    return (window.location.href = "http://10.173.18.108:9360/cas/logout");
  } else {
    window.sessionStorage.clear();
    this.clearCookie();
    let _this = this;
    QHPass.signOut(function () {
      _this.isJumpingToLogin = null;
      _this.userInfo = null;
      _this.qid = null;
      console.log(
        "退出成功：",
        _this.isJumpingToLogin,
        "用户信息：",
        _this.userInfo,
        "qid:" + _this.qid
      );
      _this.gotoLoginPage(that, res);
    });
  }
}
function gotoLoginPage(that, res) {
  if (process.env.NODE_ENV == "private") {
    return (window.location.href = "http://10.173.18.108:9360/cas/logout");
  }
  console.log("退出", that);
  if (res) {
    msg(that, res.data.errmsg, "error");
  }
  that.$router.push("/login");
  return;
  var path_ = null;
  if (that.$route.fullPath.indexOf("login?backto=") != -1) {
    // path_ = that.$route.fullPath
    path_ = "overview";
  } else {
    // if (res && res.data && res.data.errno == 700003) {
    //   //企业试用账号：未开通saas服务，自动跳转到ai页后创建新用户
    //   path_ = 'login?backto=ai?platform=official'
    // } else {
    // path_ = 'login?backto=' + that.$route.fullPath
    path_ = "login?backto=" + "overview";
    // }
  }
  if (window.location.host == "monitor.zyun.360.cn") {
    // window.location.href = 'https://console.aimonitor.360.cn/#/' + path_
    window.location.href = "https://console.aimonitor.360.cn/#/overview";
    return;
  } else {
    that.$router.push({ path: path_ });
  }
}
// 设备协议
const deviceAgreement = [
  { type: 4, name: "网络URL", isFirst: true, short_name: "网络URL" },
  { type: 3, name: "360私有协议", short_name: "360私有协议" },
  { type: 1, name: "ONVIF", boxType: 2, short_name: "ONVIF" },
  { type: 0, name: "RTSP", boxType: 2, short_name: "RTSP" },
  { type: 2, name: "国标GB/T 28181", short_name: "国标" },
];
const xiaoanKey = "21bf9b1424b47beb3dae701878fadd0f";
const livePoster = "https://p0.ssl.qhimg.com/t0199eeb170de6e0cd6.png";
let ioUrl = "wss://ws.xhm.360.cn";
if (
  window.location.href.indexOf("jinpeng") > 0 ||
  window.location.href.indexOf("test") > 0
) {
  ioUrl = "wss://t-ws.xhm.360.cn";
}
console.log("global", process.env.NODE_ENV);
if (process.env.NODE_ENV == "private") {
  ioUrl = "http://10.173.18.108:28080";
}
// const pushUrl = "rtmp://180.163.221.183:1935/live";
const pushUrl = "rtmp://pushmoniter.zyun.360.cn/smart_monitor/";
// const pullUrl = "http://180.163.221.183:8081/live";
const pullUrl = "https://flvmoniter.zyun.360.cn/smart_monitor/";
export default {
  pushUrl,
  pullUrl,
  gotoLoginPage,
  xiaoanKey,
  getKV,
  ksort,
  axios,
  signToken, // 用户token身份
  defaultUserInfo, // 默认登录用户信息
  defaultImei,
  localStorageUserInfo,
  getUrldata,
  tabsName,
  ajaxUrl,
  ajaxAdd,
  ajaxSkill,
  getMenuIndex,
  menuInfo,
  menuInfo_view,
  isJumpingToLogin,
  userInfo,
  user_Q,
  user_T,
  setCookie,
  getCookie,
  clearCookie,
  checkCookie,
  getPostData,
  getSkills,
  getTagName,
  getTagColor,
  copyData,
  formatGroupKey,
  deviceTypes,
  getModel,
  getMousePosition,
  movePanel,
  MergeArray,
  msg,
  drawSmallPic,
  drawAlarmSmallPic,
  getColorByAiId,
  draw,
  drawAlarm,
  emojiReg,
  noEmoji,
  eventTipTimer,
  eventTipNums,
  eventTipsaveNums,
  user_level,
  randomCoding,
  parseSkillData,
  time_horizons,
  allSkills,
  switchAlarm,
  livePoster,
  ioUrl,
  deviceAgreement,
  logOut,
  qid,
  removeCookie,
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Global.vue